import { message } from 'hljd'
import { action, observable, toJS } from 'mobx'

class Store {
  @observable modal_visible = false
  @observable video = null // 显示在modal中video
  @observable origin_video = null // 原video
  @observable outside_cover = null // 确定后，显示再外部空间上的封面
  @observable loading = false
  @observable saving = false
  @observable upload_percent = 0

  video_uploader = null

  getVideoFrames = (video, frameOffsets) => {
    if (!frameOffsets || !video || frameOffsets.length < 1) {
      return []
    }

    return frameOffsets.map(
      offset =>
        `${video.path}?vframe/jpg/offset/${offset}/w/${video.width}/h/${
          video.height
        }`
    )
  }

  @action
  initOriginVideo = async () => {
    this.origin_video = toJS(this.video)
  }

  /**
   * 通过服务的media信息，初始化video
   * @param media 服务器存储的media
   */
  @action
  initVideoByMedia = async media => {
    if (!media) {
      this.video = null
      this.outside_cover = null
      return
    }

    const _video = media.data
    const _path =
      _video.path ||
      (_video.cover_path && _video.cover_path.replace(/\?.*/, ''))
    this.video = {
      cover_path: _video.cover_path,
      media_id: media.id,
      height: _video.height,
      width: _video.width,
      path: _path,
      trans_path: _video.trans_path || _path,
      persistent_id: media.qiniu_persistent_id,
      compromise_path: null, // 妥协地址，加载失败后使用
      kind: 'video'
    }
    this.outside_cover = _video.cover_path
  }

  @action
  beforeUpload = (up, file) => {
    this.loading = true
  }

  @action
  uploadProgress = (up, file) => {
    if (file.percent > 99) {
      return
    }
    this.upload_percent = file.percent
  }

  @action
  handleVideoLoadError = e => {
    if (!this.video.path) {
      console.log('视频地址不存在')
    }

    const format = this.video.path.split('.')
    if (format[format.length - 1] === 'mp4') {
      // 视频无法播放，使用原视频地址尝试
      this.video.compromise_path = this.video.path
      return
    }

    // 视频不支持预览
    this.video.compromise_path = this.video.path + '?avthumb/mp4/vcodec/libx264'
  }

  /**
   * 文件上传成功的回调
   * @param up 上传控件对象
   * @param file 上传的文件
   * @param res 上传成功后的返回值
   */
  @action
  fileUploaded = (up, file, res) => {
    this.hideProgress()

    if (!res || !res.avinfo || !res.avinfo.video) {
      return
    }

    let video = res.avinfo.video
    let duration = res.avinfo.format.duration
    if (duration < 3) {
      message.warning('视频长度需大于3秒')
      return
    }

    // 视频播放url
    video.path = `${res.domain.replace(/\/$/, '')}/${res.video_path}`
    video.trans_path = video.path
    video.compromise_path = null
    video.cover_path = null
    // 取视频中的三帧作为封面预选
    video.frames = this.getVideoFrames(video, [
      0,
      Math.ceil(duration * 0.3),
      Math.ceil(duration * 0.5),
      Math.ceil(duration * 0.7)
    ])

    this.video = observable(video)
    this.video.persistent_id = res.persistent_id

    // 销毁上传控件
    up.destroy()
    this.video_uploader = null
  }

  @action
  deleteVideo = () => {
    if (this.video_uploader) {
      this.video_uploader.destroy()
    }

    this.video_uploader = null
    this.video = null
  }

  /**
   * 取消上传
   * @param isRecover 是否复原视频
   * @memberof Store
   */
  @action
  cancelUploadVideo = isRecover => {
    if (this.video_uploader) {
      this.video_uploader.destroy()
    }

    this.video_uploader = null

    setTimeout(() => {
      this.video = this.origin_video && isRecover ? this.origin_video : null
      this.origin_video = null
    })
  }

  @action
  triggerModal = () => {
    this.loading = false
    this.modal_visible = !this.modal_visible
  }

  @action
  handleCoverClick = cover_path => {
    this.video.cover_path = cover_path
  }

  @action
  hideProgress = () => {
    this.loading = false
    this.upload_percent = 0
  }
}

export default Store
